module.exports = __webpack_public_path__ + "static/media/shutterstock_2121447629.680b3857.png";